import { render, staticRenderFns } from "./tab-device.vue?vue&type=template&id=e49c8e1c&scoped=true"
import script from "./tab-device.vue?vue&type=script&lang=js"
export * from "./tab-device.vue?vue&type=script&lang=js"
import style0 from "./tab-device.vue?vue&type=style&index=0&id=e49c8e1c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49c8e1c",
  null
  
)

export default component.exports